<!--
    ReferralUpdatePage.svelte
-->

<script>
	import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import { fetchServiceById2, publicFetchServiceById2 } from '../../api/services.js';
    import { setInfoAlert, setErrorAlert } from '../../stores/AlertsStore';
    import { AccountStore } from "../../common/account";

    // TODO: this will need to be fetched!
    import { SECTION_REFERRAL_UPDATE } from "../../components/referrals/fake-referral-update.js";
    

    // TCARE components
    import PageAlert from '../../components/common/PageAlert.svelte';
    import ReferralUpdateBanner from '../../components/referrals/ReferralUpdateBanner.svelte';
    import ReferralInfo from '../../components/referrals/ReferralInfo.svelte';

    // NOTE: ReferralSections is not needed on this simpler page
    import ReferralUpdateSection from '../../components/referrals/ReferralUpdateSection.svelte';
    import { OBJECT } from '../../components/referrals/question-types.js';

    const FETCH_ERROR_MSG  = 'Error while fetching this service.';
    const SUBMIT_OK_MSG  = 'Your referral has been submitted.';

    $: serviceData = null;
    $: isFetchingData = false;
    $: isShowingDetails = false;
    $: isReferralSubmitted = false;                 // dummy only needed for <ReferralInfo>
    $: currentSection = SECTION_REFERRAL_UPDATE;

    export let params = {}				            // must define the route component prop "params"

    onMount( async () => {

        // TODO: this will probably fetch using a referral id not service id
        isFetchingData = true;
        if ($AccountStore?.isLoggedIn) {
            serviceData = await fetchServiceById2(params.id);
        } else {
            serviceData = await publicFetchServiceById2(params.id);
        }
        isFetchingData = false;

        if (serviceData.errors) {
            setErrorAlert(FETCH_ERROR_MSG, 2000);
            serviceData = null;
        }

        scrollTo(0, 0);

    })

    const showDetails = (bool) => {
        isShowingDetails = bool;
    }

    // make API call here! need required field check here too
    const submitReferral = () => {
        let reqQuest = getFirstRequiredQuestion(currentSection);
        let reqProp = getFirstRequiredProp(currentSection);
        if (!reqQuest && !reqProp) {
            setInfoAlert(SUBMIT_OK_MSG, 2000);
        } else {
            if (reqQuest) {
                showRequiredQuestionError(reqQuest);
            } else {
                showRequiredPropError(reqProp);
            }
        }
    }

    // need to know the current section first
    const getFirstRequiredQuestion = (section) => {
        if (!section) return null;
        for (const q of section.questions) {
            if (q.isRequired) {
                if (q.value === null) return q;
                if (Array.isArray(q.value) && q.value.length === 0) return q;
            }
        }
        return null;
    }

    // for OBJECT questionTypes - use 'in' not 'of'
    // must also check for empty strings, not just null
    const getFirstRequiredProp = (section) => {
        if (!section) return null;
        for (const q of section.questions) {
            if (q.questionType === OBJECT) {
                let obj = q.value;
                for (const propName in obj) {
                    if (obj[propName].isRequired) {
                        if (obj[propName].value === null || obj[propName].value === '') return obj[propName];
                    }
                }
            }
        }
        return null;
    }

    const showRequiredQuestionError = (question) => {
        const msg = 'Please answer "' + question.label + '"';
        setErrorAlert(msg, 2000);
    }

    const showRequiredPropError = (prop) => {
        const msg = 'Please complete the field "' + prop.label + '"';
        setErrorAlert(msg, 2000);
    }

</script>

<style>

    .buttons-row {
        margin-top: 40px;
        justify-content: center;
    }

</style>

<div class="page-content ref-update-page" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">

    {#if serviceData}

        <PageAlert />
        <div class="spacer-h-50"></div>

        <div class="top-section">
            <div class="flex-row">
                <div class="flex-block w-49">
                    <!-- left side of screen -->
                    <ReferralUpdateBanner />
                </div>
                <div class="flex-block w-49">
                    <!-- right side of screen -->
                    <ReferralInfo {serviceData} {showDetails} {isReferralSubmitted} />
                </div>
            </div>
        </div>

        <div class="spacer-h-25"></div>

        <div class="bottom-section">
            <ReferralUpdateSection section={currentSection} />

            <div class="flex-row buttons-row">
                <button class="tcui-button aqua" on:click={submitReferral}>Complete</button>
            </div>

            <div class="spacer-h-50"></div>
        </div>

    {:else}
        <!-- <p> Could not fetch referral service data. </p> -->
    {/if}
</div>

